class InfosClass {
  constructor() {

    this.subtitle = {
      en: "Nearby tour sites, restaurants, shops, and supers are listed below.",
      kr: "숙소 근처의 관광지, 음식점, 상점 및 슈퍼마켓 정보가 아래에 나와 있습니다.",
      jp: "近くの観光スポット、レストラン、ショップ、スーパーが以下にリストされています。",
      cn: "以下列出了附近的旅游景点、餐厅、商店和超市。",
    }

    this.tours = {
      en: {
        summary: "Please, click the proper tab in the table below.",
        subtitle: "NEARBY TOUR SITES",
        sites: [
          {
            name: "Metropolitan Building",
            access: "12 minnute walk",
            des: ["The Metropolitan Building is indeed the Tokyo government building. You can tour the observatory on the highest floor, which offers panoramic views of Tokyo and its surroundings. Additionally, visitors can collect tour information and maps there to help plan their exploration of the city."],
            photo: "photos/tour/governmentbuilding.jpg"
          },
          {
            name: "Shinjuku Gyeon",
            access: "12 minute walk",
            des: ["Shinjuku Gyeon was originally a private garden for a royal family. Now, it is a national park."],
            photo: "photos/tour/shinjukukyon.jpg"
          },
          {
            name: "Kabukicho",
            access: "4 minute walk",
            des: ["Kabukicho is indeed a vibrant entertainment district in Tokyo, known for its plethora of host and hostess clubs, love hotels, shops, restaurants, and nightclubs. Golden Gai and Samurai Museum are a few of the famous attractions."],
            photo: "photos/tour/kabukicho.jpg"
          },
          {
            name: "Korea Town",
            access: "3 minute walk",
            des: ["Koreatown (Shin Okubo) is really interesting place to visit, even though you are not into Korean idols nor spicy Korean food. Interesting spots are Korean cosmetic shops, SHOWBOX, street foods, Korean restaurants, and Don Quijote."],
            photo: "photos/tour/koreatown.jpg"
          },
          {
            name: "Samurai Museum",
            access: "6 minute walk",
            des: [
              "The Samurai swords and armor are displayed."
            ],
            photo: "photos/tour/samurai.jpg"
          },
          {
            name: "Golden Gai",
            access: "6 minute walk",
            des: [
              "Small area for architectural interest and nightlife.",
              "Composed of six narrow alleyways with about 200 small bars."
            ],
            photo: "photos/tour/goldengai.jpg"
          },
        ]
      },
      kr: {
        summary: "아래 표에서 해당 탭을 클릭하세요.",
        subtitle: "주위의 관광 포인트",
        sites: [
          {
            name: "신주쿠도청",
            access: "도보12분",
            des: ["메트로폴리탄 빌딩은 실제로 도쿄의 정부 건물입니다. 최고 층의 관람대를 투어할 수 있으며, 도쿄와 주변 지역의 원주민 경치를 즐길 수 있습니다. 게다가 방문자들은 도시 탐험 계획을 돕기 위해 여기에서 관광 정보와 지도를 수집할 수 있습니다."],
            photo: "photos/tour/governmentbuilding.jpg"
          },
          {
            name: "신주쿠교엔",
            access: "도보12분",
            des: ["신주쿠 교엔은 원래 왕실 가족을 위한 사적 정원이었습니다. 지금은 국립 공원으로 운영되고 있습니다."],
            photo: "photos/tour/shinjukukyon.jpg"
          },
          {
            name: "가부키쵸",
            access: "도보4분",
            des: ["가부키쵸는 도쿄의 활기찬 엔터테인먼트 지구로, 호스트 및 호스티스 클럽, 러브 호텔, 상점, 레스토랑, 나이트 클럽 등이 많이 있어 유명합니다. 골든 가이와 사무라이 박물관은 그 중 몇 가지 유명한 관광 명소입니다."],
            photo: "photos/tour/kabukicho.jpg"
          },
          {
            name: "코리아타운",
            access: "도보3분",
            des: ["코리아타운(신오쿠보)은 한국 아이돌이나 매운 한국 음식을 좋아하지 않더라도 방문하기에 정말 흥미로운 곳입니다. 흥미로운 곳은 한국 화장품 매장, SHOWBOX, 길거리 음식, 한식당, 돈키호테입니다."],
            photo: "photos/tour/koreatown.jpg"
          },
          {
            name: "사무라이  박물관",
            access: "도보6분",
            des: ["사무라이의 검과 갑옷이 전시되어 있습니다."],
            photo: "photos/tour/samurai.jpg"
          },
          {
            name: "골든가이",
            access: "도보6분",
            des: ["건축학적 관심과 밤의 유흥을 즐길 수 있는 작은 지역. 약 200개의 작은 바가 있는 6개의 좁은 골목으로 구성되어 있습니다."],
            photo: "photos/tour/goldengai.jpg"
          },
        ]
      },
      jp: {
        summary: "以下の表の適切なタブをクリックしてください。",
        subtitle: "近くのツアー会場",
        sites: [
          {
            name: "東京都庁舎",
            access: "徒歩12分",
            des: ["都庁舎は確かに東京都庁舎です。最上階の展望台を見学することができ、東京とその周辺のパノラマの景色を楽しむことができます。また、ここでツアー情報や地図を集めて、街の探索を計画するのに役立ちます。"],
            photo: "photos/tour/governmentbuilding.jpg"
          },
          {
            name: "新宿御苑",
            access: "徒歩12分",
            des: ["もともとは王室専用の庭園でした。現在は国立公園になっています。"],
            photo: "photos/tour/shinjukukyon.jpg"
          },
          {
            name: "歌舞伎町",
            access: "徒歩4分",
            des: ["歌舞伎町は、東京の活気あるエンターテイメント地区であり、ホストクラブ、ホステスクラブ、ラブホテル、ショップ、レストラン、ナイトクラブなどが数多くあります。ゴールデン街とサムライ博物館は、その中でも有名な観光スポットの一部です。"],
            photo: "photos/tour/kabukicho.jpg"
          },
          {
            name: "コリアンタウン",
            access: "徒歩3分",
            des: ["Koreatown（新大久保）は、韓国のアイドルや辛い韓国料理に興味がなくても訪れる価値がある興味深い場所です。韓国の化粧品店、SHOWBOX、屋台料理、韓国料理店、そしてドン・キホーテなど、興味深いスポットがあります。"],
            photo: "photos/tour/koreatown.jpg"
          },
          {
            name: "サムライミュージアム",
            access: "徒歩6分",
            des: ["武士の刀や甲冑が展示されています。"],
            photo: "photos/tour/samurai.jpg"
          },
          {
            name: "ゴールデン街",
            access: "徒歩6分",
            des: ["建築物とナイトライフのための小さなエリア。6 本の狭い路地で構成されており、小さなバーが約 200 軒あります。"],
            photo: "photos/tour/goldengai.jpg"
          },
        ]
      },
      cn: {
        summary: "请单击下表中的适当选项卡。",
        subtitle: "附近的旅游景点",
        sites: [
          {
            name: "东京都政府大楼",
            access: "徒歩12分",
            des: ["都庁大厦确实是东京的政府大楼。您可以参观位于最顶层的观景台，从那里欣赏东京及其周边地区的全景。此外，游客还可以在那里收集旅游信息和地图，帮助计划他们的城市探索行程。"],
            photo: "photos/tour/governmentbuilding.jpg"
          },
          {
            name: "新宿御苑",
            access: "徒歩12分",
            des: ["新宿御苑原本是皇室的私人花园。现在已成为国家公园。"],
            photo: "photos/tour/shinjukukyon.jpg"
          },
          {
            name: "歌舞伎町",
            access: "徒歩4分",
            des: ["歌舞伎町确实是东京一个充满活力的娱乐区，以其众多的主题酒吧、情侣酒店、商店、餐厅和夜总会而闻名。黄金街和武士博物馆是其中几个著名景点。"],
            photo: "photos/tour/kabukicho.jpg"
          },
          {
            name: "韩国城",
            access: "徒歩3分",
            des: ["韩国城（新大久保）确实是一个很有趣的地方，即使你对韩国偶像或辣的韩国食物不感兴趣也是如此。有趣的地方包括韩国化妆品店、SHOWBOX、街头小吃、韩国餐厅和唐吉坷德。"],
            photo: "photos/tour/koreatown.jpg"
          },
          {
            name: "武士(Samurai)博物馆",
            access: "徒歩6分",
            des: ["展示了武士刀和盔甲。"],
            photo: "photos/tour/samurai.jpg"
          },
          {
            name: "金盖(Golden Gai)",
            access: "徒歩6分",
            des: [
              "面积不大，适合建筑兴趣和夜生活。",
              "由6条狭窄的小巷组成，约有200家小酒吧。"],
            photo: "photos/tour/goldengai.jpg"
          },
        ]
      },
    }

    this.supers = {
      en: {
        summary: "Please, click the proper tab in the table below.",
        subtitle: "NEARBY SUPERS",
        sites: [
          {
            name: "Santoku",
            access: "8 minute walk",
            des: [
              "It is a mid sized super. Open till 10 PM."
            ],
            photo: "photos/supers/santoku.jpg"
          },
          {
            name: "Co-Op Super",
            access: "8 minute walk",
            des: [
              "It is a super right across from Santoku.",
              "Open till 10 PM."
            ],
            photo: "photos/supers/coop.jpg"
          },
          {
            name: "Hanamasa Super",
            access: "4 minute walk",
            des: [
              "It is a super mainly for business.",
              "They allow non-business guests as well."
            ],
            photo: "photos/supers/hamanasa.jpg"
          },
        ]
      },
      kr: {
        summary: "아래 목록에서 적당한 탭을 클릭하세요.",
        subtitle: "근처의 수퍼",
        sites: [
          {
            name: "산토쿠 수퍼",
            access: "도보8분",
            des: ["산토쿠 수퍼는 중형 수퍼입니다. 저녁 10시까지 엽니다."
            ],
            photo: "photos/supers/santoku.jpg"
          },
          {
            name: "코압수퍼(Co-Op Super)",
            access: "도보8분",
            des: ["산토쿠수퍼 바로 길건너편에 위치합니다. 저녁 10시까지 영업합니다."],
            photo: "photos/supers/coop.jpg"
          },
          {
            name: "하나마사 수퍼",
            access: "도보4분",
            des: ["비지니스 수퍼이나, 일반 고객도 구입가능합니다."],
            photo: "photos/supers/hamanasa.jpg"
          },
        ]
      },
      jp: {
        summary: "以下の表の適切なタブをクリックしてください。",
        subtitle: "近くのスーパー",
        sites: [
          {
            name: "santoku スーパー",
            access: "徒歩8分",
            des: ["中型スーパーです。夜10時まで営業しています。"],
            photo: "photos/supers/santoku.jpg"
          },
          {
            name: "Co-Op スーパー",
            access: "徒歩8分",
            des: ["Santoku スーパーの真向かいにあります。22時まで営業しています。"],
            photo: "photos/supers/coop.jpg"
          },
          {
            name: "ハナマサスーパー",
            access: "徒歩4分",
            des: ["ビジネスメインのスーパーです。ビジネス以外のお客様もご利用いただけます。"],
            photo: "photos/supers/hamanasa.jpg"
          },
        ]
      },
      cn: {
        summary: "请单击下表中的适当选项卡。",
        subtitle: "附近的超市",
        sites: [
          {
            name: "Santoku 超市",
            access: "徒歩8分",
            des: [
              "这是一家中型超市。营业至晚上 10 点。"],
            photo: "photos/supers/santoku.jpg"
          },
          {
            name: "Co-Op 超市",
            access: "徒歩8分",
            des: ["这是一家位于 Santoku 对面的超级餐厅。营业至晚上 10 点。"],
            photo: "photos/supers/coop.jpg"
          },
          {
            name: "Hanamasa 超市",
            access: "徒歩4分",
            des: ["这是一家主要针对商务客人的超级酒店。他们也允许非商务客人入住。"],
            photo: "photos/supers/hamanasa.jpg"
          },
        ]
      },
    }
    this.shops = {
      en: {
        summary: "Please, click the proper tab in the table below.",
        subtitle: "NEARBY SHOPS",
        sites: [
          {
            name: "Donkey Jote",
            access: "5 minute walk",
            des: [
              "It is an interesting place with lots of goods at reasonable price.",
              "Crowded most of times."
            ],
            photo: "photos/shops/donkey.jpg"
          },
          {
            name: "BICQLO",
            access: "10 minute walk",
            des: ["BICQLO = Bic Camera + Uniqlo. They sell Electronics and clothes."],
            photo: "photos/shops/viccamera.jpg"
          },
          {
            name: "Isetan Department Store",
            access: "10 minute walk",
            des: ["It is a huge department store. Their Food Court is very popular."],
            photo: "photos/shops/isetan.jpg"
          },
          {
            name: "CanDo (100 yen shop)",
            access: "6 minute walk",
            des: ['Everything is 100 yen. It is a amazing place.'],
            photo: "photos/shops/cando.jpg"
          }
        ]
      },
      kr: {
        summary: "아래 적당한 탭을 클릭하세요.",
        subtitle: "근처 상점",
        sites: [
          {
            name: "동키호테",
            access: "도보5분",
            des: ["온갖 상품을 합리적인 가격에 팔고있습니다. 아주 흥미로운 곳입니다. 대부분 시간대에 복잡합니다."],
            photo: "photos/shops/donkey.jpg"
          },
          {
            name: "BICQLO",
            access: "도보10분",
            des: ["BICQLO = Bic Camera + Uniqlo. 가전, 카메라, 컴퓨터 및 의류도 판매합니다."],
            photo: "photos/shops/viccamera.jpg"
          },
          {
            name: "이세탄 백화점",
            access: "도보10분",
            des: ["굉장히 큰 백화점입니다. 지하의 푸드코트는 유명합니다."],
            photo: "photos/shops/isetan.jpg"
          },
          {
            name: "CanDo (백엔샵)",
            access: "도보6분",
            des: ['모든 제품이 100엔입니다. 아주 흥미로운 곳입니다.'],
            photo: "photos/shops/cando.jpg"
          }
        ]
      },
      jp: {
        summary: "以下の表の適切なタブをクリックしてください。",
        subtitle: "近くのお店",
        sites: [
          {
            name: "ドン・キホーテ",
            access: "徒歩5分",
            des: ["リーズナブルな価格で商品がたくさんある面白いお店です。ほとんどの場合混雑しています。"],
            photo: "photos/shops/donkey.jpg"
          },
          {
            name: "BICQLO",
            access: "徒歩10分",
            des: ["ビックロ＝ビックカメラ＋ユニクロ。電化製品や衣類を販売しています。"],
            photo: "photos/shops/viccamera.jpg"
          },
          {
            name: "伊勢丹百貨店",
            access: "徒歩10分",
            des: ["巨大なデパートです。フードコートはとても人気があります。"],
            photo: "photos/shops/isetan.jpg"
          },
          {
            name: "CanDo（100円ショップ）",
            access: "徒歩6分",
            des: ['どれも100円です。素晴らしい場所です。'],
            photo: "photos/shops/cando.jpg"
          }
        ]
      },
      cn: {
        summary: "请单击下表中的适当选项卡。",
        subtitle: "附近的商店",
        sites: [
          {
            name: "Donkey Jote",
            access: "徒歩5分",
            des: ["Donkey Jote这是一个有趣的地方，有很多价格合理的商品。大部分时间都很拥挤。"
            ],
            photo: "photos/shops/donkey.jpg"
          },
          {
            name: "BICQLO",
            access: "徒歩10分",
            des: ["BICQLO = Bic Camera + Uniqlo。他们卖电子产品和衣服。"],
            photo: "photos/shops/viccamera.jpg"
          },
          {
            name: "伊势丹百货店",
            access: "徒歩10分",
            des: ["这是一个巨大的百货商店。他们的美食广场很受欢迎。"
            ],
            photo: "photos/shops/isetan.jpg"
          },
          {
            name: "CanDo（百日元店）",
            access: "徒歩6分",
            des: ['所有东西都是100日元。这是一个很棒的地方。'],
            photo: "photos/shops/cando.jpg"
          }
        ]
      },
    }
    this.restaurants = {
      en: {
        summary: "Please, click the proper tab in the table below.",
        subtitle: "NEARBY RESTAURANTS",
        sites: [
          {
            name: "Matsuya Korean Restaurant",
            access: "2 minute walk",
            des:  ["Almost every year, the restaurant is ranked about 10th by NHK survey. Little front garden is well decorated with real flowers. The most popular menu is pork bone soup which is known as Gamjatang."],
            photo: "photos/restaurants/pinetreehouse.png"
          },
          {
            name: "Sushi Zanmai",
            access: "2 minute walk",
            des: ["It is very well known Sushi Restaurant. You should expect a long waiting line during lunch and dinner hour."],
            photo: "photos/restaurants/sushizanmai.png"
          },
          {
            name: "Matsunoya Tonkatsu",
            access: "3 minute walk",
            des: ["It is one of major food franchises in Japan. Tasty food at reasonable price."],
            photo: "photos/restaurants/matsunoya.png"
          },
          {
            name: "Sukiya",
            access: "3 minute walk",
            des: ["It may be number one food franchise brand in Japan. Main menu is Kyudon."],
            photo: "photos/restaurants/sukiya.png"
          },
          {
            name: "Ikinari Steak House",
            access: "2 minute walk",
            des: ["When Ikinari started its business, there were no chairs, aiming for fast turnarounds. Now, they provide chairs."],
            photo: "photos/restaurants/ikinari.png"
          },
          {
            name: "Isomaru Izakaya",
            access: "2 minute walk",
            des: ["Well-known Japanese Izakaya. They offer mostly sea food with drinks."],
            photo: "photos/restaurants/isomaru.png"
          }
        ]
      },
      jp: {
        summary: "以下の表の適切なタブをクリックしてください。",
        subtitle: "近くのレストラン",
        sites: [
          {
            name: "松屋 韓国レストラン",
            access: "徒歩2分",
            des: ["NHKの調査では毎年のように10位前後にランクインしているお店です。小さな前庭は本物の花でよく飾られています。一番人気は豚骨スープのカムジャタンです。"],
            photo: "photos/restaurants/pinetreehouse.png"
          },
          {
            name: "寿司 Zanmai",
            access: "徒歩2分",
            des: ["とても有名なお寿司屋さんです。ランチとディナーの時間帯には長い行列ができることが予想されます。"],
            photo: "photos/restaurants/sushizanmai.png"
          },
          {
            name: "松の屋 とんかつ",
            access: "徒歩3分",
            des: ["日本を代表する大手食品フランチャイズの一つです。リーズナブルな価格でおいしい料理。"],
            photo: "photos/restaurants/matsunoya.png"
          },
          {
            name: "すき家",
            access: "徒歩3分",
            des: ["おそらく日本でナンバーワンの食品フランチャイズブランドです。メインメニューは牛丼。"],
            photo: "photos/restaurants/sukiya.png"
          },
          {
            name: "いきなり ステーキハウス",
            access: "徒歩2分",
            des: ["いきなりが事業を始めたときは、早い回転を目指して椅子はありませんでした。今では椅子も用意されています。"],
            photo: "photos/restaurants/ikinari.png"
          },
          {
            name: "磯丸 居酒屋",
            access: "徒歩2分",
            des: ["言わずと知れた日本の居酒屋。彼らは主にシーフードと飲み物を提供しています。"],
            photo: "photos/restaurants/isomaru.png"
          }
        ]
      },
      cn: {
        summary: "请单击下表中的适当选项卡。",
        subtitle: "附近的餐厅",
        sites: [
          {
            name: "松屋韩国餐厅",
            access: "步行2分钟",
            des: ["几乎每年，该餐厅在 NHK 调查中排名第 10 名左右。前面的小花园用真花装饰得很好。最受欢迎的菜单是猪骨汤，称为 Gamjatang。"],
            photo: "photos/restaurants/pinetreehouse.png"
          },
          {
            name: "Sushi Zanmai",
            access: "步行2分钟",
            des: ["这是一家非常有名的寿司店。午餐和晚餐时间您应该会排很长的队。"],
            photo: "photos/restaurants/sushizanmai.png"
          },
          {
            name: "Matsunoya Tonkatsu",
            access: "步行3分钟",
            des: ["它是日本主要的食品特许经营店之一。美味的食物，价格合理。"],
            photo: "photos/restaurants/matsunoya.png"
          },
          {
            name: "Sukiya",
            access: "步行3分钟",
            des: ["它可能是日本排名第一的食品特许经营品牌。主菜单是牛丼。"],
            photo: "photos/restaurants/sukiya.png"
          },
          {
            name: "Ikinari Steak House",
            access: "步行2分钟",
            des: ["当他们开始营业时，没有椅子，目的是快速周转。现在，他们提供椅子。" ],
            photo: "photos/restaurants/ikinari.png"
          },
          {
            name: "Isomaru Izakaya",
            access: "步行2分钟",
            des: ["知名的日本居酒屋。他们主要提供海鲜和饮料。"],
            photo: "photos/restaurants/isomaru.png"
          },
        ]
      },
      kr: {
        summary: "아래에서 적당한 탭을 클릭하세요.",
        subtitle: "근처 식당",
        sites: [
          {
            name: "마쯔야 한국식당",
            access: "도보2분",
            des: ["NHK가 10위 이내에 랭크시키는 유명한 한식당입니다. 식당앞의 작은 정원은 조화가 아니며 매우 정성스럽게 꾸며져 있습니다. 감자탕으로 유명합니다."],
            photo: "photos/restaurants/pinetreehouse.png"
          },
          {
            name: "쓰시 잔마이",
            access: "2 mins walk",
            des: ["아주 유명한 쓰시식당입니다. 식사시간대에는 긴 줄을 예상해야 합니다."
            ],
            photo: "photos/restaurants/sushizanmai.png"
          },
          {
            name: "마쯔노야 돈가스",
            access: "3 mins walk",
            des: ["일본의 유명한 돈가스 체인점입니다. 싸고 맛있습니다."],
            photo: "photos/restaurants/matsunoya.png"
          },
          {
            name: "수키야",
            access: "3 mins walk",
            des: ["아마도 음식체인점 중에서 가장 가맹점이 많은 브랜드입니다. 주 메뉴는 규돈입니다."],
            photo: "photos/restaurants/sukiya.png"
          },
          {
            name: "이키나리 스테익",
            access: "2 mins walk",
            des: ["개점당시 빠른 회전율을 노려 의자를 제공하지 않았으나, 이제는 의자를 제공합니다."
            ],
            photo: "photos/restaurants/ikinari.png"
          },
          {
            name: "이소마루 이자카야",
            access: "2 mins walk",
            des: ["많이 알려진 일본 이자카야입니다. 주로 해산물과 주류를 판매합니다."
            ],
            photo: "photos/restaurants/isomaru.png"
          }
        ]
      },
    }
  }

  get_tours_info(lang) {
    switch (lang) {
      case 'en': return this.tours.en
      case 'kr': return this.tours.kr
      case 'jp': return this.tours.jp
      case 'cn': return this.tours.cn
    }
  }
  get_supers_info(lang) {
    switch (lang) {
      case 'en': return this.supers.en
      case 'kr': return this.supers.kr
      case 'jp': return this.supers.jp
      case 'cn': return this.supers.cn
    }
  }
  get_shops_info(lang) {
    switch (lang) {
      case 'en': return this.shops.en
      case 'kr': return this.shops.kr
      case 'jp': return this.shops.jp
      case 'cn': return this.shops.cn
    }
  }
  get_restaurants_info(lang) {
    switch (lang) {
      case 'en': return this.restaurants.en
      case 'kr': return this.restaurants.kr
      case 'jp': return this.restaurants.jp
      case 'cn': return this.restaurants.cn
    }
  }
  get_subtitle(lang) {
    switch (lang) {
      case 'en': return this.subtitle.en
      case 'kr': return this.subtitle.kr
      case 'jp': return this.subtitle.jp
      case 'cn': return this.subtitle.cn
    }
  }
}
export let info_utils = new InfosClass();